class ServiceController {
  constructor() {
    this.name = 'service';
  }
}

export default ServiceController;



// WEBPACK FOOTER //
// ./client/app/components/service/service.controller.js